import { createApp } from 'vue'
import App from './App.vue'
import axios from 'axios'
window.axios = require('axios')

const clientId = document.getElementById('cc-2609-app').getAttribute('data-id');
const app = createApp(App, { clientId: clientId });

// Mount the app
const vm = app.mount('#cc-2609-app');

// Make vm available globally
global.vm = vm;
